// Percorso file: src/utils/denaro.js
//
// IL DENARO A SCHERMO — sede unica della forma con cui User List e la
// finestra Payments mostrano un importo in dollari. Solo visualizzazione:
// nessun calcolo, filtro, ordinamento o colore legge questa stringa (quelli
// lavorano sul numero), e l'Export CSV non la usa.
//
// Norma (decisa dal committente, cantiere MIGLIAIA):
// 1. n = Number(x);
// 2. n non finito → "—" (trattino lungo);
// 3. n arrotondato a 2 decimali; uno zero (anche -0) vale 0 positivo;
// 4. "$" + spazio stretto (U+202F) + n.toLocaleString("en-AU", 2 decimali).
// Forma copiata da `importo` di components/MemberProfileModal.jsx (stessa
// di ClubFinance.jsx): nessun segno + / − aggiunto a mano, un negativo
// esce col meno di toLocaleString dopo lo spazio ("$ -20.00").
export function denaroAschermo(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return "—";
  const arrotondato = Number(n.toFixed(2));
  const valore = arrotondato === 0 ? 0 : arrotondato;
  return (
    "$ " +
    valore.toLocaleString("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  );
}
